var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { TranslateService } from '@ngx-translate/core';
import { OrderService } from './../../order/order.service';
import { CurrentOrderService } from './../../order/currentOrder.service';
import { FlagService } from './../../modules/features/flag.service';
import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
var OrderDetailComponent = (function () {
    function OrderDetailComponent(route, flag, router, currentOrderService, translate) {
        this.route = route;
        this.flag = flag;
        this.router = router;
        this.currentOrderService = currentOrderService;
        this.translate = translate;
        this.language = this.translate.currentLang;
    }
    OrderDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isAlgoliaSearchActive = this.flag.isAlgoleaSearchActive();
        this.isFileItemActive = this.flag.isFileItemActive();
        this.isFilePOActive = this.flag.isFilePOActive();
        this.route.data.subscribe(function (data) {
            _this.order = data.request;
        });
    };
    OrderDetailComponent.prototype.duplicate = function () {
        this.currentOrderService.resetAll();
        this.order.PurchaseOrderNumber = "";
        this.order.id = OrderService.generateUUID();
        this.currentOrderService.setOrder(this.order);
        this.router.navigate(['/dashboard/' + this.order.orderType + '/part']);
    };
    OrderDetailComponent = __decorate([
        Component({
            selector: 'cx-dashboard-order',
            templateUrl: './order-detail.component.html',
            styles: ["\n  h2{\n    color:#0d3461;\n    font-weight:400;\n  }\n  h3{\n    color:#0d3461;\n    font-size:1.5em;\n  }\n  .wrapper-content{\n    max-width:1000px;\n    margin-left:auto;\n    margin-right:auto;\n  }\n  "]
        }),
        __metadata("design:paramtypes", [ActivatedRoute,
            FlagService,
            Router,
            CurrentOrderService,
            TranslateService])
    ], OrderDetailComponent);
    return OrderDetailComponent;
}());
export { OrderDetailComponent };
var OrderDetailGuard = (function () {
    function OrderDetailGuard() {
    }
    OrderDetailGuard.prototype.canActivate = function () {
        return true;
    };
    OrderDetailGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], OrderDetailGuard);
    return OrderDetailGuard;
}());
export { OrderDetailGuard };
//# sourceMappingURL=order-detail.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/order-details/order-detail.component.js
// module id = 260
// module chunks = 0